// Generated by pnpm generate:metadata after rebuilding WASM. Do not edit.
import type { Language, LanguageMetadata } from "../../../yap-frontend-rs/pkg";

export const LANGUAGE_METADATA = {
  English: {
    isoCode: 'eng',
    iso6391: 'en',
    status: 'stable',
    icon: 'eng.liberty',
    nativeName: 'English',
    englishName: 'English',
    commonName: 'English',
    people: 'English',
    badge: 'EN',
    script: undefined,
    accentedCharacters: [],
    characterType: undefined,
    iSpeak: 'I speak English',
    yaptownName: 'Yap.Town',
    letsGo: "Let's go!"
  },
  French: {
    isoCode: 'fra',
    iso6391: 'fr',
    status: 'stable',
    icon: 'fra.eiffel',
    nativeName: 'Français',
    englishName: 'French',
    commonName: 'French',
    people: 'French',
    badge: 'FR',
    script: undefined,
    accentedCharacters: [
      'à',
      'â',
      'é',
      'è',
      'ê',
      'ë',
      'î',
      'ï',
      'ô',
      'ù',
      'û',
      'ü',
      'ÿ',
      'ç',
      'œ',
      'æ'
    ],
    characterType: 'accented',
    iSpeak: 'Je parle français',
    yaptownName: 'Yap.Ville',
    letsGo: 'Allons-y !'
  },
  SpanishLatinAmerican: {
    isoCode: 'spa',
    iso6391: 'es',
    status: 'stable',
    icon: 'spa.calavera',
    nativeName: 'Español',
    englishName: 'Spanish (Latin America)',
    commonName: 'Spanish',
    people: 'Spanish',
    badge: 'LATAM',
    script: undefined,
    accentedCharacters: [
      'á',
      'é',
      'í',
      'ó',
      'ú',
      'ü',
      'ñ',
      '¿',
      '¡'
    ],
    characterType: 'accented',
    iSpeak: 'Hablo español',
    yaptownName: 'Yap.Ciudad',
    letsGo: '¡Vamos!'
  },
  SpanishPeninsular: {
    isoCode: 'spa-es',
    iso6391: 'es',
    status: 'stable',
    icon: 'spa-es.sagrada',
    nativeName: 'Español',
    englishName: 'Spanish (Spain)',
    commonName: 'Spanish',
    people: 'Spanish',
    badge: 'ES',
    script: undefined,
    accentedCharacters: [
      'á',
      'é',
      'í',
      'ó',
      'ú',
      'ü',
      'ñ',
      '¿',
      '¡'
    ],
    characterType: 'accented',
    iSpeak: 'Hablo español',
    yaptownName: 'Yap.Ciudad',
    letsGo: '¡Vamos!'
  },
  German: {
    isoCode: 'deu',
    iso6391: 'de',
    status: 'stable',
    icon: 'deu.neuschwanstein',
    nativeName: 'Deutsch',
    englishName: 'German',
    commonName: 'German',
    people: 'German',
    badge: 'DE',
    script: undefined,
    accentedCharacters: [
      'ä',
      'ö',
      'ü',
      'ß',
      'Ä',
      'Ö',
      'Ü'
    ],
    characterType: 'accented',
    iSpeak: 'Ich spreche Deutsch',
    yaptownName: 'Yap.Stadt',
    letsGo: "Los geht's!"
  },
  Italian: {
    isoCode: 'ita',
    iso6391: 'it',
    status: 'beta',
    icon: 'ita.pisa',
    nativeName: 'Italiano',
    englishName: 'Italian',
    commonName: 'Italian',
    people: 'Italian',
    badge: 'IT',
    script: undefined,
    accentedCharacters: [
      'à',
      'è',
      'é',
      'ì',
      'ò',
      'ù'
    ],
    characterType: 'accented',
    iSpeak: 'Parlo italiano',
    yaptownName: 'Yap.Città',
    letsGo: 'Andiamo!'
  },
  PortugueseBrazilian: {
    isoCode: 'por',
    iso6391: 'pt',
    status: 'beta',
    icon: 'por.cristo',
    nativeName: 'Português',
    englishName: 'Portuguese (Brazil)',
    commonName: 'Portuguese',
    people: 'Portuguese',
    badge: 'BR',
    script: undefined,
    accentedCharacters: [
      'á',
      'é',
      'í',
      'ó',
      'ú',
      'â',
      'ê',
      'ô',
      'ã',
      'õ',
      'ç'
    ],
    characterType: 'accented',
    iSpeak: 'Eu falo português',
    yaptownName: 'Yap.Cidade',
    letsGo: 'Vamos lá!'
  },
  PortugueseEuropean: {
    isoCode: 'por-pt',
    iso6391: 'pt',
    status: 'beta',
    icon: 'por-pt.tram',
    nativeName: 'Português',
    englishName: 'Portuguese (Portugal)',
    commonName: 'Portuguese',
    people: 'Portuguese',
    badge: 'PT',
    script: undefined,
    accentedCharacters: [
      'á',
      'é',
      'í',
      'ó',
      'ú',
      'â',
      'ê',
      'ô',
      'ã',
      'õ',
      'ç'
    ],
    characterType: 'accented',
    iSpeak: 'Eu falo português',
    yaptownName: 'Yap.Cidade',
    letsGo: 'Vamos lá!'
  },
  Russian: {
    isoCode: 'rus',
    iso6391: 'ru',
    status: 'alpha',
    icon: 'rus.basil',
    nativeName: 'Русский',
    englishName: 'Russian',
    commonName: 'Russian',
    people: 'Russian',
    badge: 'RU',
    script: undefined,
    accentedCharacters: [],
    characterType: 'Cyrillic',
    iSpeak: 'Я говорю по-русски',
    yaptownName: 'Yap.Город',
    letsGo: 'Пойдём!'
  },
  Korean: {
    isoCode: 'kor',
    iso6391: 'ko',
    status: 'beta',
    icon: 'kor.gyeongbokgung',
    nativeName: '한국어',
    englishName: 'Korean',
    commonName: 'Korean',
    people: 'Korean',
    badge: 'KO',
    script: undefined,
    accentedCharacters: [],
    characterType: 'hangul',
    iSpeak: '한국어를 합니다',
    yaptownName: '얍.타운',
    letsGo: '가자!'
  },
  Japanese: {
    isoCode: 'jpn',
    iso6391: 'ja',
    status: 'alpha',
    icon: 'jpn.torii',
    nativeName: '日本語',
    englishName: 'Japanese',
    commonName: 'Japanese',
    people: 'Japanese',
    badge: 'JA',
    script: undefined,
    accentedCharacters: [],
    characterType: 'Japanese',
    iSpeak: '日本語を話します',
    yaptownName: 'Yap.町',
    letsGo: '行こう！'
  },
  ChineseSimplified: {
    isoCode: 'zho-hans',
    iso6391: 'zh',
    status: 'alpha',
    icon: 'zho-hans.panda',
    nativeName: '简体中文',
    englishName: 'Chinese (Simplified)',
    commonName: 'Chinese',
    people: 'Chinese',
    badge: 'ZH',
    script: 'Hans',
    accentedCharacters: [],
    characterType: 'Chinese',
    iSpeak: '我说中文',
    yaptownName: 'Yap.城',
    letsGo: '走吧！'
  },
  ChineseTraditional: {
    isoCode: 'zho-hant',
    iso6391: 'zh',
    status: 'alpha',
    icon: 'zho-hant.boba',
    nativeName: '繁體中文',
    englishName: 'Chinese (Traditional)',
    commonName: 'Chinese',
    people: 'Chinese',
    badge: 'ZHT',
    script: 'Hant',
    accentedCharacters: [],
    characterType: 'Chinese',
    iSpeak: '我說中文',
    yaptownName: 'Yap.城',
    letsGo: '走吧！'
  },
  Hindi: {
    isoCode: 'hin',
    iso6391: 'hi',
    status: 'alpha',
    icon: 'hin.tajmahal',
    nativeName: 'हिन्दी',
    englishName: 'Hindi',
    commonName: 'Hindi',
    people: 'Hindi-speaking',
    badge: 'HI',
    script: undefined,
    accentedCharacters: [],
    characterType: 'Devanagari',
    iSpeak: 'मैं हिन्दी बोलता हूँ',
    yaptownName: 'यैप.टाउन',
    letsGo: 'चलो!'
  },
  Thai: {
    isoCode: 'tha',
    iso6391: 'th',
    status: 'alpha',
    icon: 'tha.elephant',
    nativeName: 'ไทย',
    englishName: 'Thai',
    commonName: 'Thai',
    people: 'Thai',
    badge: 'TH',
    script: undefined,
    accentedCharacters: [],
    characterType: 'Thai',
    iSpeak: 'ฉันพูดภาษาไทย',
    yaptownName: 'Yap.เมือง',
    letsGo: 'ไปกันเลย!'
  }
} as const satisfies Record<Language, LanguageMetadata>;
